// extracted by mini-css-extract-plugin
export var highlightFade = "_3i-4";
export var highlighted = "_3i-3";
export var table = "_3i-1";
export var tableContainer = "_3i-0";
export var totalsRow = "_3i-2";